const marketingRoutes = [
  {
    path: "/marketing/infos-marques",
    name: "marketing-infos-marques",
    component: () => import("@/views/marketing/InfosMarques.vue"),
    meta: {
      layout: "content",
      resource: "marketing",
      action: "manage",
    },
  },
  {
    path: "/marketing/data-import",
    name: "marketing-data-import",
    component: () => import("@/views/marketing/DataImport.vue"),
    meta: {
      layout: "content",
      resource: "marketing",
      action: "manage",
    },
  },
  {
    path: "/marketing/data-matching",
    name: "marketing-data-matching",
    component: () => import("@/views/marketing/DataMatching.vue"),
    meta: {
      layout: "content",
      resource: "marketing",
      action: "manage",
    },
  },
  {
    path: "/marketing/view-imported-data",
    name: "marketing-view-imported-data",
    component: () => import("@/views/marketing/ViewImportedData.vue"),
    meta: {
      layout: "content",
      resource: "marketing",
      action: "manage",
    },
  },
  {
    path: "/marketing/generate-presentations",
    name: "marketing-generate-presentations",
    component: () => import("@/views/marketing/GeneratePresentations.vue"),
    meta: {
      layout: "content",
      resource: "marketing",
      action: "manage",
    },
  },
  {
    path: "/marketing/source-settings",
    name: "marketing-source-settings",
    component: () => import("@/views/marketing/SourceSettings.vue"),
    meta: {
      layout: "content",
      resource: "marketing",
      action: "manage",
    },
  },
  {
    path: "/marketing/debug",
    name: "marketing-debug",
    component: () => import("@/views/marketing/Debug.vue"),
    meta: {
      layout: "content",
      resource: "marketing",
      action: "manage",
    },
  },
];

export default marketingRoutes;
